import {useState, useContext,useEffect ,useRef} from 'react';

import './biometricID.scss';
import classes from './bioId.module.scss';
import SubmitBtn from '../../Form/submit-button/submit-button.component';
import idCard from '../../../assets/icons/id-card.svg';
import tzBio from '../../../assets/img/tz-bio2.png';
import smartCardReader from '../../../assets/icons/smart-card-reader.svg';
import code from '../../../assets/icons/code-stars.svg';
import idImg from '../../../assets/img/bio_id.svg';
// import arrowRightBlue from '../../../assets/icons/arrow-right-blue.svg';
import LoginContext from '../../../store/login-context';
// import outlineRepeat from '../../../assets/icons/outline_repeat.svg';
import BackLink from '../../General/Static/BackLink/BackLink';

declare function Translate(key: string): string;
declare var _loginMethodIsraelSmartCardUrl;
declare var _loginMethodSmsOtpUrl: any;
declare var _loginType: any;
declare var _loginTypeLoa4Landing: any;

const handleClick = () => {
  //Delete prefered login type if rava 4
  if(_loginType === _loginTypeLoa4Landing){
    localStorage.removeItem("preferredLoginType"); 
  }
  
  window.location.href = _loginMethodIsraelSmartCardUrl;
};

export const BiometricID = () => {
  // const backRef:any = useRef();
  const ctx = useContext(LoginContext);

  const [isActive_0,setIsActive_0] = useState(true);
  const [isActive_1,setIsActive_1] = useState(false);
  const [isActive_2,setIsActive_2] = useState(false);
  const [isActive_3,setIsActive_3] = useState(false);

  // useEffect(() => {
  //   if(_loginType !== _loginTypeLoa4Landing){
  //     backRef.current.focus();
  //   }    
  // },[]) 

  const activeChangedHandler = (event) =>{    
    switch(event.currentTarget.id){
      case '0':
        setIsActive_0(!isActive_0);
        setIsActive_1(false);
        setIsActive_2(false);
        setIsActive_3(false);
        break;
      case '1':
        setIsActive_0(false);
        setIsActive_1(!isActive_1);
        setIsActive_2(false);
        setIsActive_3(false);
        break;
      case '2':
        setIsActive_0(false);
        setIsActive_1(false);
        setIsActive_2(!isActive_2);
        setIsActive_3(false);
        break;
      case '3':
        setIsActive_0(false);
        setIsActive_1(false);
        setIsActive_2(false);
        setIsActive_3(!isActive_3);
        break;
      default:
        break;
    }
  }

  const keyPressActiveChangedHandler = (event) => {
    if (event.charCode === 13){
      activeChangedHandler(event);
    }
  }

  const onBackHandler = () => {
    localStorage.removeItem("preferredLoginType"); 
    window.location = _loginMethodSmsOtpUrl;
  }

  // const onBackPress = (event) => {
  //   event.preventDefault();
  //   if (event.charCode === 13 || event.charCode === 32){
  //     onBackHandler();
  //   }
  // };

  const onScHandler = () => {
    ctx.scSelected();
  }

  const handleNoReaderClick = () => {        
      window.open("https://www.gov.il/he/pages/signup_sso_faq");
  }; 

  const handleNoReaderPress = (e) => {
      if (e.keyCode === 13 || e.keyCode === 32){
        handleNoReaderClick();
      }
  }

  const onBioIdActiveClick = () => {         
    window.open("https://www.gov.il/he/service/activation_of_smart_indentification_card", "_blank");     
  };

  const onBioIdActivePress = (event) => {
    event.preventDefault();  
    if (event.charCode === 13 || event.charCode === 32){  
        onBioIdActiveClick();  
    }  
  };

  var bodyText = Translate('N_Login_biometric_id_info_6');
  var link1 = Translate('*link4*');
  var link1Tag = '*link4*';
  var link1Arr = bodyText.split(link1Tag); 
  
  return (
    <>
      {/* <div className={classes.up_note}>
        <div role="heading" aria-level={1} className={classes.title}>{Translate('N_Login_info_1')}</div>
        <div role="heading" aria-level={2} className={classes.subTitle}>{Translate('N_Login_Sub_Title')}</div>
      </div> */}
      <div className="bio_id_wrapper">
        <form className='normal-form'>                    
          {_loginType !== _loginTypeLoa4Landing &&
            <BackLink back={onBackHandler} loginType="" translate={Translate('N_Login_application_pop_up_3')}/>
          }
          {_loginType === _loginTypeLoa4Landing && 
            <BackLink back={onScHandler} loginType="Loa4Landing" translate={Translate('N_Login_smart_card_tab_title')}/>
          }    
          <div className='loginHeading m-b-8' role="heading" aria-level={2}>
            <img
              className=''
              src={idImg}
              alt='' 
              aria-hidden="true"                         
            />
            <div className='title'>
              <span> {Translate('N_Login_biometric_id_title')} </span>
            </div>
          </div>
          <div className='text-center' aria-hidden="true">
            <img src={tzBio} alt='' width={140}  />
          </div>
          <div className={classes.main}>           
              <div className={classes.desc}>
                <span className={classes.desc_title}>
                  {Translate('N_Login_biometric_id_info_1')}                
                </span>
                <section>                  
                  <div className={classes.desc_item}>
                    <img src={idCard} aria-hidden="true" className={classes.desc_img}/>
                    <span>
                      {Translate('N_Login_biometric_id_info_2')}
                      <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                        <span className="gov-tooltiptitle">{Translate('N_Login_biometric_id_info_2_2')}</span>
                        <span className="gov-tooltiptext" tabIndex={0}>
                          <span>{Translate('N_Login_biometric_id_info_id')}</span><br/>
                          <a id='bioIdActive' tabIndex={0} 
                              className="gov-tooltip-link"
                              onClick={onBioIdActiveClick}
                              onKeyPress={onBioIdActivePress}
                          >
                              {Translate('N_Login_biometric_id_info_id_link')}
                          </a>
                        </span>  
                      </a> 
                    </span>                                      
                  </div>                                      
                  <div className={classes.desc_item}>
                    <img src={code}  aria-hidden="true" className={classes.desc_img}/>
                    <span>
                      {Translate('N_Login_biometric_id_info_4')}
                      <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                        <span className="gov-tooltiptitle">{Translate('N_Login_biometric_id_info_4_2')}</span>
                        <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_biometric_id_info_code')}</span>
                      </a>                
                    </span>                                   
                  </div>
                  <div className={classes.desc_item}>
                    <img src={smartCardReader}  aria-hidden="true" className={classes.desc_img}/>
                    <span>
                      {Translate('N_Login_biometric_id_info_3')}
                      <a className='gov-tooltip tooltipLink' tabIndex={0} role='button'>
                        <span className="gov-tooltiptitle">{Translate('N_Login_Bio_ID_What_is_biometric_ID')}</span>
                        <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_biometric_id_info_reader')}</span>
                      </a>
                    </span>                
                  </div>
                </section>

                <div className={classes.remark_wrapper}>
                  <div className={classes.remark_icon}>
                      !
                  </div>
                  <div className={classes.remark_desc}>
                    <div>
                      {Translate('N_Login_Software_Rem')}
                    </div>
                    <div>
                      {Translate('N_Login_Software_Rem_2')}
                      <a className='gov-tooltip tooltipLink small' tabIndex={0} role='button'>
                        <span className="gov-tooltiptitle">{Translate('N_Login_Software_Info')}</span>
                        <span className="gov-tooltiptext" tabIndex={0}>{Translate('N_Login_Software_Bio_ID_Tooltip')}</span>
                      </a>
                    </div>
                  </div>  
                </div> 
              </div>                                                                
          </div> 
          <div className={classes.note} >
            <div
                id='noReaderOrCode'
                className={classes.no_reader_link}
                role='link'
                tabIndex={0}
                onKeyDown={handleNoReaderPress}
                onClick={handleNoReaderClick}                        
            >
              {Translate('N_Login_No_Reader_Or_Code')}        
            </div> 
          </div>
          <div className={classes.btn_wrapper}> 
            <div className={classes.btn_sub_wrapper}>                         
              <SubmitBtn
                title={Translate('N_Login_biometric_id_button')}
                id="bioIdSubmit"
                action={handleClick}
                showIcon={true}
                disabled={false}
              /> 
            </div> 
          </div>                                                      
        </form>
      </div>
    </>
  );
};

export default BiometricID;
